import { useQuery, useMutation } from "./helper";
import {
    getAllDevicesForUser,
    getDevice,
    getDeviceList,
    getDeviceListForUser,
    getDeviceRegistrationStatus,
    GetTotalsForUser,
    GetDeviceTelemetryData,
    GetAverageTelemetryData,
    assignDeviceOwner,
    removeDeviceAsOwner,
    addDeviceAsOperator,
    removeDeviceAsOperator,
    addDeviceAsDealer,
    removeDeviceAsDealer,
    getAllDevices,
    getAllFusionDevices
} from "../../../api/device";
import { TResponseItemWrapper, TResponseListWrapper } from "../../types/common";
import { TDevice, TDeviceDetails, TelemetryData } from "../../types";

export const useDeviceList = (params, options) => useQuery<TResponseListWrapper<TDevice>>({
    queryKey: ['devices', params],
    queryFn: () => getDeviceList(params),
    ...options,
});

export const useDeviceUsersList = (userId, params, options) => useQuery<TResponseListWrapper<TDevice>>({
    queryKey: ['devices-by-user', userId, params],
    queryFn: () => getDeviceListForUser(userId, params),
    ...options,
});

export const useAllDevicesForUser = (userId, options) => useQuery<TResponseItemWrapper<TDevice[]>>({
    queryKey: ['all-devices-for-user', userId],
    queryFn: () => getAllDevicesForUser(userId),
    ...options,
});

export const useTotalsForUser = (userId, options) => useQuery<TResponseItemWrapper<{ totalDevices: number, totalOnlineDevices: number }>>({
    queryKey: ['totals-for-user', userId],
    queryFn: () => GetTotalsForUser(userId),
    ...options,
});

export const useDevice = (deviceSerialNumber: string, options) => useQuery<TResponseItemWrapper<TDeviceDetails>>({
    queryKey: ['device', deviceSerialNumber],
    queryFn: () => getDevice(deviceSerialNumber),
    ...options,
});

export const useDeviceRegistrationStatus = (deviceSerialNumber, options) => useQuery({
    queryKey: ['device-registration-status', deviceSerialNumber],
    queryFn: () => getDeviceRegistrationStatus(deviceSerialNumber),
    ...options,
});

export const useDeviceTelemetryData = (deviceSerialNumber, options) => useQuery({
    queryKey: ['device-telemetry-data', deviceSerialNumber],
    queryFn: () => GetDeviceTelemetryData(deviceSerialNumber),
    ...options,
});

export const useAverageTelemetryData = (jobId, options) => useQuery<TResponseItemWrapper<TelemetryData>>({
    queryKey: ['device-telemetry-data', jobId],
    queryFn: () => GetAverageTelemetryData(jobId),
    ...options,
});

export const useAssignDeviceOwner = () => useMutation({
    mutationFn: assignDeviceOwner,
});

export const useRemoveDeviceAsOwner = () => useMutation({
    mutationFn: removeDeviceAsOwner,
});

export const useAddDeviceAsOperator = () => useMutation({
    mutationFn: addDeviceAsOperator,
});

export const useRemoveDeviceAsOperator = () => useMutation({
    mutationFn: removeDeviceAsOperator,
});

export const useAddDeviceAsDealer = () => useMutation({
    mutationFn: addDeviceAsDealer,
});

export const useRemoveDeviceAsDealer = () => useMutation({
    mutationFn: removeDeviceAsDealer,
});

export const useAllDevices = (options) => useQuery<TResponseItemWrapper<TDevice[]>>({
    queryKey: ['all-devices'],
    queryFn: () => getAllDevices(),
    ...options,
});

export const useAllFusionDevices = (options) => useQuery<TResponseItemWrapper<TDevice[]>>({
    queryKey: ['all-fusion-devices'],
    queryFn: () => getAllFusionDevices(),
    ...options,
});
